<div class="modal-header">
    <h4 class="modal-title  pull-left">{{title}}</h4>
    <button type="button" class="close" data-dismiss="modal" (click)="bsModalRef.hide()">×</button>
  </div>
  <div class="modal-body">
   {{list}}
     <!-- <div *ngFor="let item of list">{{list[0]}}</div>-->
    
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-link-default btn-xs" (click)="close(true)">{{closeBtnName}}</button>
  </div>
  